import { render, staticRenderFns } from "./VendTableMain.vue?vue&type=template&id=8f7ecbd0"
import script from "./VendTableMain.vue?vue&type=script&lang=js"
export * from "./VendTableMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports